module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/fiscal-doc/fiscal-doc.component.css
// module id = ./src/app/components/fiscal-doc/fiscal-doc.component.css
// module chunks = main